/* This is quite similar to the api.contributionRequests() endpoint, 
but with a different authentication method and without roomId.
Therefore, we decided to keep it separate here */

export const api = {
    loadContributionRequestWithToken: (): string =>
        '/api/contribution_requests/?mode=published&include_closed=true'
};
